import { useContext } from 'react'
import { RosterSetupContext } from '../RosterSetup'
import { cn } from '@/lib/utils'

type Props<T> = {
  title: string
  subject: Record<string, T>
  memberFilterFn: (member: wowaudit.TeamMembership, matchEntities: T) => boolean
  valueFn: (type: string, matchEntities: T) => React.ReactNode
  className?: string
}

const StatTable = <T,>({
  title,
  subject,
  memberFilterFn,
  valueFn,
  className = '',
}: Props<T>) => {
  const { mains, alts } = useContext(RosterSetupContext)

  return (
    <div className={cn('bg-background rounded-lg px-3 py-2', className)}>
      <table className='w-full'>
        <thead>
          <tr className='[&>th]:px-2 [&>th:first-child]:pl-0 [&>th]:font-normal [&>th]:text-xs'>
            <th className='text-left'>{title}</th>
            <th>Main</th>
            <th>Alt</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(subject).map(([type, matchEntities]) => {
            const mainCount = mains.filter((member) =>
              memberFilterFn(member, matchEntities),
            ).length
            const altCount = alts.filter((member) =>
              memberFilterFn(member, matchEntities),
            ).length

            return (
              <tr key={type} className='border-t border-accent'>
                <td>
                  <div
                    className={`flex items-center gap-1.5 mr-2 whitespace-nowrap ${
                      mainCount > 0 ? '' : '[&_span]:opacity-60 [&_span]:italic'
                    }`}
                  >
                    {valueFn(type, matchEntities)}
                  </div>
                </td>
                <td className='text-center' width='10%'>
                  {mainCount || <span className='opacity-30'>-</span>}
                </td>
                <td className='text-center' width='10%'>
                  {altCount || <span className='opacity-30'>-</span>}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default StatTable
